/* G Decor — relabel the variant picker "Colour" → "Design" on product pages.
   v2 · 26-Sep-2026
   v1 walked every text node inside <main> and replaced the word "colour"
   wherever it appeared, so it rewrote product titles ("Door Knob in Colour"
   became "Door Knob in Design") and descriptions ("so the colour stays warm"
   became "so the Design stays warm").
   v2 touches ONLY the option label (the <legend> of each option selector),
   and only when that label itself begins with Colour / Color. */
(function(){
  if(!document.body.classList.contains('template-product')) return;

  var SEL = 'variant-picker legend, [data-variant-picker] legend, .option-selector legend, .option-selector__label';
  var LABEL = /^(\s*)(colou?r)\b/i;

  function sweep(){
    var els = document.querySelectorAll(SEL);
    for (var i = 0; i < els.length; i++) {
      // The label word is the first non-empty text node; the selected
      // value sits in its own <span> and is left alone.
      for (var n = els[i].firstChild; n; n = n.nextSibling) {
        if (n.nodeType !== 3) continue;
        var t = n.nodeValue;
        if (!t || !t.trim()) continue;
        if (LABEL.test(t)) n.nodeValue = t.replace(LABEL, '$1Design');
        break;
      }
    }
  }

  function start(){
    sweep();
    var timer;
    var mo = new MutationObserver(function(){
      clearTimeout(timer);
      timer = setTimeout(sweep, 80);
    });
    // The theme re-renders the variant picker on variant change.
    var target = document.querySelector('.product-info, .product, main') || document.body;
    mo.observe(target, { childList: true, subtree: true });
  }

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
